import Vue from "vue";
import {ActionTree, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import axios from "axios";
import {SERVERS_HOST_LIST} from "@/config";
import api from "@/service/api";
import {con} from "@/helpers/console";
import ApiError from "@/service/ApiError";
import any = jasmine.any;

export interface State {
    images: any;
    countries: [any] | []
}

const defaultState: State = {
    images: {},
    countries: []
};

const getters = {
    imageById: (state: State) => (id: string) => state.images[id],
    getCountries: (state: State) => state.countries
};

const mutations: MutationTree<State> = {
    addImage(state, data: any) {
        let {id, url} = data;
        Vue.set(state.images, id, url);
    },

    setCountries(state, data) {
        state.countries = data
    }
};

const actions: ActionTree<State, RootState> = {
    async getCountryFromServer({commit, state}) {
        if (!state.countries.length) {
            try {
                const {data} = await api.go('getCountries')
                const d1= data.map((el:any)=>{return {...el,phoneCode:Number(el.phoneCode)}})
                commit('setCountries', d1.sort((a:any,b:any)=>a.phoneCode > b.phoneCode ? 1 : -1))
            } catch (error) {
                commit('dialog/SetFullError',{
                    titleError:"что-то пошло не так",
                    subtitleError:error.response.status+': '+error.response.statusText,
                    textContentError:JSON.stringify(error.response),
                    isCopyError:true,
                    isBtnLogout:false,
                    isBtnSupport:true,
                },{root:true})

            }
        }
    },
    async getCountryFromServerHard({commit}) {
        try {
            const {data} = await api.go('', {baseURL: SERVERS_HOST_LIST[0], url: 'v4/countries', method: 'get'})
            commit('setCountries', data)
        } catch (error) {
            console.log(error);
        }
    },
    async addImage({commit}, data) {
        try {
            let {photoKey, shardId} = data;
            const req: any = await Vue.axios({
                url: "/media-links",
                method: "POST",
                data: {
                    keys: [photoKey],
                },
            });
            let url = "";
            fetch(req.data[photoKey]).then((res) =>
                res
                    .clone()
                    .blob()
                    .then((ib) => {
                        commit("addImage", {id: shardId, url: URL.createObjectURL(ib)});
                    })
            );
        } catch (error) {
            console.log(error);
        }
    },
};

export default {
    namespaced: true,
    state: defaultState,
    getters,
    mutations,
    actions,
};
